import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LiveLessonLabel as LiveLessonLabelComponent } from '@lean-body/components/atoms';
import { Colors } from '@lean-body/components/styles';
export const LiveLessonCardHeader = ({ label, holdingTime, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(LiveLessonLabelComponent, { labelText: label.name, textColor: label.textColor, backgroundColor: label.backgroundColor }),
        React.createElement("div", { className: css(styles.holdingTime) }, holdingTime)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    holdingTime: {
        color: Colors.Black,
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: 0.56,
    },
});
